/**
 * @file: description
 * @author:
 * @Date: 2020-03-24 17:34:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-31 16:31:25
 */
import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  PageableResultSubjectVO,
  ParamssubjectsListUsingGet,
  ParamssubjectsSubjectIdAddArticlesUsingPost,
  ParamsBodysubjectsUsingPost,
  SubjectVO,
  ParamssubjectsSubjectIdUsingPut,
  ParamsBodysubjectsSubjectIdAddArticlesUsingPost,
  ParamsBodysubjectsUsingDelete
} from '@src/services';
import { message } from 'antd';
import { PAGE_SIZE } from '@src/utils/constant/common';

export interface State {
  thematicList: PageableResultSubjectVO;
  loading: boolean;
}

export const thematicModelState: State = {
  thematicList: {},
  loading: false
};

const model = CM({
  state: thematicModelState,
  namespace: 'thematicModel',
  reducers: {
    /** 设置专题列表 */
    setThematicList: (
      state,
      action: Tction<{ thematicList: PageableResultSubjectVO }>
    ): typeof state => {
      const { thematicList } = action.payload;
      return {
        ...state,
        thematicList
      };
    },
    /** 更新loading */
    updateLoading: (state, action: Tction<{ loading: boolean }>): typeof state => {
      const { loading } = action.payload;
      return {
        ...state,
        loading
      };
    },
    /** 更新loading */
    updateThematicList: (state, action: Tction<{ thematicInfo: SubjectVO }>): typeof state => {
      const { thematicInfo } = action.payload;
      const {
        thematicList: { list }
      } = state;
      return {
        ...state,
        thematicList: {
          ...state.thematicList,
          list: list?.map(item => {
            if (item.id === thematicInfo.id) {
              return {
                ...thematicInfo
              };
            } else {
              return { ...item };
            }
          })
        }
      };
    }
  },
  effects: {
    /** 获取专题列表 */
    *getThematicList(
      { tPut, tCall },
      action: Tction<{ params: ParamssubjectsListUsingGet; needLoading?: boolean }>
    ): Iterator<{}, any, any> {
      const { params, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: true });
      }

      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsListUsingGet> = yield tCall(
        APIS.SubjectApi.subjectsListUsingGet,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setThematicList, { thematicList: res.result || {} });
      } else {
        message.error(res.message);
      }
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: false });
      }
    },

    /** 更新专题 */
    *updateThematic(
      { tPut, tCall },
      action: Tction<{
        params: ParamssubjectsSubjectIdUsingPut;
        data: SubjectVO;
      }>
    ): Iterator<{}, any, any> {
      const { params, data } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsSubjectIdUsingPut> = yield tCall(
        APIS.SubjectApi.subjectsSubjectIdUsingPut,
        params,
        data
      );
      if (res.code === 0) {
        yield tPut(model.actions.updateThematicList, { thematicInfo: data });
        message.success('更新成功');
      } else {
        message.error(res.message);
      }
    },
    /** 添加专题文章 */
    *addThematicArtList(
      { tPut, tCall },
      action: Tction<{
        params: ParamssubjectsSubjectIdAddArticlesUsingPost;
        data: ParamsBodysubjectsSubjectIdAddArticlesUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { params, data } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsSubjectIdAddArticlesUsingPost> = yield tCall(
        APIS.SubjectApi.subjectsSubjectIdAddArticlesUsingPost,
        params,
        data
      );
      if (res.code === 0) {
        message.success('专题文章添加成功');
      } else {
        message.error(res.message);
      }
    },
    /** 添加精选专题 */
    *addThematicList(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodysubjectsUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { data } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsUsingPost> = yield tCall(
        APIS.SubjectApi.subjectsUsingPost,
        data
      );
      if (res.code === 0) {
        yield tPut(model.actions.getThematicList, { params: { pageNum: 1, pageSize: PAGE_SIZE } });
        message.success('精选专题添加成功');
      } else {
        message.error(res.message);
      }
    },
    /** 删除精选专题 */
    *deleteThematicList(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodysubjectsUsingDelete;
        pageNum: number;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, pageNum, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsUsingDelete> = yield tCall(
        APIS.SubjectApi.subjectsUsingDelete,
        data
      );
      if (res.code === 0) {
        yield tPut(model.actions.getThematicList, {
          params: { pageNum, pageSize: PAGE_SIZE },
          needLoading: false
        });
        callBack && callBack();
        message.success('精选专题删除成功');
      } else {
        message.error(res.message);
      }
    }
  }
});

/**
 * @description 全局Model thematicModel 挂载到 redux 上
 */
export default model;
